import _regeneratorRuntime from "/www/wwwroot/kft.ycxxkj.com/admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/www/wwwroot/kft.ycxxkj.com/admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import util from "@/libs/util";
import helper from "@/libs/helper.js";
import axios from "@/plugin/axios";
export default {
  name: "app",
  watch: {
    "$i18n.locale": "i18nHandle"
  },
  created: function created() {
    this.i18nHandle(this.$i18n.locale);
    if (localStorage["admin_id"]) {
      this.loadMenu(); //加载左侧菜单
    }
  },

  methods: {
    i18nHandle: function i18nHandle(val, oldVal) {
      util.cookies.set("lang", val);
      document.querySelector("html").setAttribute("lang", val);
    },
    loadMenu: function loadMenu() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, url, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              //加载菜单
              data = {
                id: localStorage["admin_id"]
              };
              console.log("menu data", data);
              url = helper.apiHost + helper.apiUrl.menuList;
              _context.next = 5;
              return axios({
                url: url,
                method: "post",
                data: data
              });
            case 5:
              res = _context.sent;
              console.log("menu res", res);
              _this.$store.commit("d2admin/menu/asideSet", res.data.menu);
              _this.$store.commit("d2admin/menu/roleSet", res.data.role);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};